/**
 * Formato de lectura para métricas del dashboard (es-AR):
 * - Enteros menores a 1.000 sin separador (ej. 999)
 * - A partir de 1.000 (4+ cifras) separador de miles con punto (ej. 22.450)
 * - Decimales con coma como separador decimal
 */
export function formatDashboardNumber(value: number): string {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return String(value)
  }

  const abs = Math.abs(value)

  if (abs < 1000) {
    if (Number.isInteger(value)) {
      return String(value)
    }
    return value.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 4 })
  }

  return value.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 4 })
}
